export default __webpack_public_path__ + "static/media/vault.a84c5fb6.png";